let language = {
    "COUPON-ALERT-MISSING-TITLE": "缺少优惠券代码",
    "COUPON-ALERT-MISSING-CONTENT": "您输入的优惠券代码为空，请输入有效的优惠券代码。",
    "COUPON-ALERT-MAX-TITLE": "优惠券超过最大限制",
    "DIRECT-CHECKOUT-ENTRY-COUPON-ALERT-MAX-CONTENT": "您只能使用一张优惠券。请检查数量并重试。",
    "COUPON-ALERT-DUPLICATE-TITLE": "重复的优惠券代码",
    "COUPON-ALERT-DUPLICATE-CONTENT": "此优惠券代码已在本订单中使用过，请更换其他优惠券代码并重试。",
    "COUPON-ALERT-REMOVE-TITLE": "移除优惠券代码",
    "COUPON-ALERT-REMOVE-CONTENT": "您确定要移除此优惠券代码吗？",
};

export { language }
